import { translate } from '@shakkerai/util-i18n';
import { wrapImageElement } from './Image';
import { wrapImageOverlayer } from './Overlayer';
import { ColorAdjustPanel } from './Panel';
import { initialState } from './state';

const name = 'colorAdjustment';

const colorAdjustor = {
  type: 'custom',

  defaultData: initialState,

  methods: {},

  // 获取输入端口
  getInputPorts: (data) => {
    return [];
  },

  // 获取输出端口
  getOutputPorts: (data) => {
    return [
      {
        type: 'image',
        name: 'image',
        label: 'xxxx',
      },
    ];
  },

  // 设置输入
  setInput: (name, value, data) => {
    return { ...data, [name]: value };
  },

  // 设置输出
  getInput: (name, data) => {
    return data[name];
  },

  getOutput: (name, data) => {
    // 返回输出数据
    return data?.imageUrl;
  },

  // 执行函数
  execute: async ({ data, element }) => {
    // 拿到数据，执行操作
    // helpers.updateElement()

    return data;
  },
};

export default {
  // 模块的唯一标识符
  type: name,

  // 这个会在模块初始化的时候执行，用于注册一些扩展功能
  setup: async ({ app }) => {
    // // 这里对图片元素本身和图片元素的覆层组件进行了包装
    // app.extension.wrapElement('image', { element: wrapImageElement, overlayer: wrapImageOverlayer });
    // // 注册一个新的图片工具类型
    // app.extension.registerElementTool({
    //   name: name,
    //   // label: translate('调色'),
    //   // icon: 'shk-tiaozhengyanse',
    //   handler: ({ selection }) => {
    //     if (selection.length !== 1) return;
    //     if (selection[0].split('-')[1] !== 'image') return;
    //     enterDerivativeFromElement(name, selection[0], { forceCreate: true });
    //   },
    // });
    // // 注册一个新的右侧面板
    // app.extension.registerComponent('right_panel', {
    //   Component: ColorAdjustPanel,
    //   config: {
    //     name: name,
    //   },
    // });
    // app.extension.registerProcessor(name, colorAdjustor);
  },
};
